import {clickEvent} from "../../webpack/modules/events";
import {addItem, openCart, updateItemsNumber} from "../../webpack/modules-optimized/cart";
import {hideModal, showModal} from "../../webpack/modules-optimized/modal";

clickEvent('#premium .btn-add-to-cart', true, async function(element) {
    await addItem({'productId': element.dataset.id, 'quantity': 1, 'isLocked': true});
    openCart();
    updateItemsNumber(true);
});

